import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  DateToMMDDYYYY,
  formatDate,
  localTimeDifference,
} from "../../../utils/utilities";
import {
  getAssessSpec,
  cloneAssessSpec,
  deleteAssessSpec,
  archiveAssessSpec,
  resetCurrAssessSpec,
} from "../../../redux/thunks/AssessSpec";
import { useMediaQuery } from "@mui/material";
import { PathName } from "../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { secondsTohhmm } from "../../../utils/utilities";
import { RequestStatus } from "../../../utils/Constants";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import TestDetailedView from "./TestDetailedView";
import Table from "../../../components/common/Table";
import AssessmentCriteria from "./AssessmentCriteria";
import TestDetailsRightView from "./TestDetailsRightView";
import CustomModal from "../../../components/common/Modal";
import AlertBox from "../../../components/common/AlertBox";
import Button from "../../../components/sub-component/Button";
import CustomTooltip from "../../../components/common/CustomTooltip";
import { CommonContext } from "../../../utils/contexts/CommonContext";
import { GetAvtarImage } from "../../../components/dashboard/AvtarBadge";
import { patchAssessmentHiringStage } from "../../../redux/thunks/Assessment";
import ProcessingIndicator from "../../../components/common/ProcessingIndicator";
import LastActivity from "../../../assets/icons/Views/dashboard/test-detail/Vector.png";
import { ReactComponent as ProfilePic } from "../../../assets/icons/components/sidebar/user.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/Views/dashboard/assessments/info.svg";
import { ReactComponent as LinkIcon } from "../../../assets/icons/Views/dashboard/test-detail/link.svg";
import { ReactComponent as CopyIcon } from "../../../assets/icons/Views/dashboard/test-detail/copy.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/Views/dashboard/test-detail/edit.svg";
import { ReactComponent as MinimizeIcon } from "../../../assets/icons/components/dashboard/minimize.svg";
import { ReactComponent as ShareIcon } from "../../../assets/icons/Views/dashboard/test-detail/share.svg";
import { ReactComponent as TrashIcon } from "../../../assets/icons/Views/dashboard/test-detail/trash2.svg";
import { ReactComponent as FileIcon } from "../../../assets/icons/Views/dashboard/test-detail/file-text.svg";
import { ReactComponent as ArchiveIcon } from "../../../assets/icons/Views/dashboard/test-detail/archive.svg";
import { ReactComponent as CreatedIcon } from "../../../assets/icons/Views/dashboard/assessments/check-circle.svg";
import { ReactComponent as BackArrowIcon } from "../../../assets/icons/Views/dashboard/test-detail/left-arrow.svg";
import { ReactComponent as LeftArrowIcon } from "../../../assets/icons/Views/dashboard/assessments/arrow-left.svg";
import { ReactComponent as TimeStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/time-stats.svg";
import { ReactComponent as TimerIcon } from "../../../assets/icons/Views/dashboard/test-detail/HourglassMedium(1).svg";
import { ReactComponent as ExpiryStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/expiry-stats.svg";
import { ReactComponent as InvitedStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/invite-stats.svg";
import { ReactComponent as AttemptsStatsIcon } from "../../../assets/icons/Views/dashboard/assessments/attempt-stats.svg";
import { ReactComponent as AssessmentUploadImageIcon } from "../../../assets/icons/Views/dashboard/assessments/default-upload.svg";

export default function TestDetails(props) {
  const isOnSmallWebScreen = useMediaQuery(
    "(min-width:1199px) and (max-width:1390px)",
  );
  const isOnTabletScreen = useMediaQuery(
    "(min-width:768px) and (max-width:1199px)",
  );
  const isOnWebScreen = useMediaQuery("(min-width:1200px)");
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");

  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const users = useSelector((state) => state.userReducer);
  const auth = useSelector((state) => state.authReducer);
  const assessSpec = useSelector((state) => state.assessSpecReducer);

  const [alert, setAlert] = useState(null);
  const [testData, setTestData] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [navOptions, setNavOptions] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [isCandDetails, setIsCandDetails] = useState(true);
  const [actionBtnOpen, setActionBtnOpen] = useState(false);
  const [transformedData, setTransformedData] = useState([]); // Add new state for transformed data
  const [selectedRowIndex, setSelectedRowIndex] = useState();
  const [selectedNavLink, setSelectedNavLink] = useState("all");
  const [isRightMenuOpen, setIsRightMenuOpen] = useState(false);
  const [curr_assessment_spec, setCurr_assessment_spec] = useState(
    assessSpec?.curr_assessment_spec,
  );
  const [highlightActiveRow, setHighlightActiveRow] = useState(false);
  const [deleteAssessmentModal, setDeleteAssessmentModal] = useState({
    isOpen: false,
  });
  const [archiveAssessmentModal, setArchiveAssessmentModal] = useState({
    isOpen: false,
  });

  const { commonValues, setCommonValues } = useContext(CommonContext);

  const assesment = assessSpec?.data?.results?.find(
    (assessment) => assessment?.id === assessSpec?.curr_assessment_spec?.id,
  );
  const completedAssessment =
    assessSpec?.curr_assessment_spec?.assessments &&
    assessSpec?.curr_assessment_spec?.assessments.filter(
      (assess) => assess?.status === "FINISHED",
    );

  const defaultFilterOptions = [
    { name: "All Candidate(s)", value: "all", count: 0 },
    { name: "Pending", value: "PENDING", count: 0 },
    { name: "In Progress", value: "IN_PROGRESS", count: 0 },
    { name: "Completed", value: "FINISHED", count: 0 },
    { name: "Declined", value: "DECLINED", count: 0 },
    { name: "Not Qualified", value: "NOT_QUALIFIED", count: 0 },
    { name: "Invite Bounced", value: "INVITE_BOUNCED", count: 0 },
  ];

  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const saved = localStorage.getItem("testDetailsRowsPerPage");
    return saved ? Math.min(parseInt(saved, 10), 100) : 10;
  });
  const [currentPage, setCurrentPage] = useState(1);
  const searchParams = new URLSearchParams(location.search);
  const selectedStatus = searchParams.get("status") || "";
  const selectedHiringStage = searchParams.get("hiring_stage") || "";
  const selectedSearch = searchParams.get("search") || "";
  const selectedSortColumn = searchParams.get("sortColumn") || "";
  const selectedSortOrder = searchParams.get("sortOrder")
    ? searchParams.get("sortOrder").toUpperCase()
    : "";
  const selectedSortBy = {
    score: "cum_score_obj",
    created_at: "created_at",
    updated_at: "updated_at",
  }[selectedSortColumn];
  const [selectedsortOption, setSelectedsortOption] = useState({
    column: selectedSortColumn,
    order: ["ASC", "DESC"].includes(selectedSortOrder)
      ? selectedSortOrder
      : "DESC",
    clickCount: 0,
  });

  useEffect(() => {
    setSelectedsortOption((prev) => ({
      ...prev,
      column: selectedSortColumn,
      order: ["ASC", "DESC"].includes(selectedSortOrder)
        ? selectedSortOrder
        : "DESC",
    }));
  }, [selectedSortColumn, selectedSortOrder]);

  const handleRowsPerPageChange = (newLimit) => {
    const cappedLimit = Math.min(newLimit, 100);
    setItemsPerPage(cappedLimit);
    setCurrentPage(1);
    localStorage.setItem("testDetailsRowsPerPage", cappedLimit);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const hasResultParam = queryParams.get("result");

    if (hasResultParam && assessSpec?.curr_assessment_spec?.assessments) {
      setIsRightMenuOpen(true);
      setSelectedRow(
        assessSpec?.curr_assessment_spec?.assessments.filter(
          (assesment) => assesment.id == hasResultParam,
        )[0],
      );
    } else {
      setIsRightMenuOpen(false);
    }
  }, [location.search, assessSpec]);

  useEffect(() => {
    if (!curr_assessment_spec?.assessments) return;

    const newTransformedData = curr_assessment_spec.assessments.map(
      (assessment) => ({
        name: (
          <div
            style={{ marginLeft: "24px", marginTop: "2px" }}
            className="d-flex align-items-baseline"
          >
            {assessment.user?.first_name || assessment.user?.last_name
              ? `${assessment.user?.first_name || ""}
            ${assessment.user?.last_name || ""}`
              : `${assessment?.email || "-"}`}
          </div>
        ),
        createdAt: assessment.created_at,
        updatedAt: assessment.updated_at,
        candidatesStatus: (
          <div
            key="1"
            className="candidate-status-container body-2"
            style={{
              border: assessment.status !== "FINISHED" ? "1px solid black" : "",
              background:
                assessment.status === "FINISHED" ? "#7C21FF" : "#FFFFFF",
              color: assessment.status === "FINISHED" ? "#FFF" : "#121216",
            }}
          >
            {assessment.status === "PENDING"
              ? "Pending"
              : assessment.status === "IN_PROGRESS"
                ? "In Progress"
                : assessment.status === "NOT_QUALIFIED"
                  ? "Not Qualified"
                  : assessment.status === "DECLINED"
                    ? "Declined"
                    : assessment.status === "EXPIRED"
                      ? "EXPIRED"
                      : assessment.status === "INVITE_BOUNCED"
                        ? "Invite Bounced"
                        : "Completed"}
          </div>
        ),
        score: assessment.cum_score
          ? assessment.cum_score === null
            ? "N/A"
            : `${Math.round(assessment.cum_score * 100)}%`
          : assessment?.cum_score_obj
            ? `${parseFloat(
                (10 / 1) * assessment?.cum_score_obj?.score,
              ).toFixed(1)}`
            : "N/A",
        ...assessment,
        hiringStage: `${
          assessment?.hiring_stage?.charAt(0).toUpperCase() +
          assessment?.hiring_stage?.toLowerCase()?.slice(1)
        }`,
        user: {
          name: `${assessment.user?.first_name || ""} ${
            assessment.user?.last_name || ""
          }`,
          email: assessment.email,
          ...assessment.user,
        },
      }),
    );

    setTestData(newTransformedData);
    setTransformedData(newTransformedData); // Set the transformed data state
  }, [curr_assessment_spec]);

  const handleClose = () => {
    setIsRightMenuOpen(false);
    setHighlightActiveRow(false);
    setCommonValues({
      ...commonValues,
      isSideBarExpanded: true,
      detailedTestView: { isExpanded: false, testType: null, data: null },
    });

    if (searchParams.has("result")) {
      const id = location.pathname.split("/").pop();
      history.push(`/dashboard/assessments/${id}`);
    }
  };
  const testTableHeader = [
    {
      id: "name",
      name: "Candidates",
      type: "string",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab", "mob"],
    },
    {
      id: "score",
      name: "Job Fit Score",
      type: "string",
      disableSorting: true,
      backendSorting: true,
      screens: ["web", "tab", "mini_tab"],
    },
    {
      id: "candidatesStatus",
      name: "Status",
      type: "component",
      disableSorting: true,
      enableFilter: true,
      filterName: "status",
      filterOptions: [
        { name: "Pending", value: "PENDING" },
        { name: "In Progress", value: "IN_PROGRESS" },
        { name: "Completed", value: "FINISHED" },
        { name: "Declined", value: "DECLINED" },
        { name: "Not Qualified", value: "NOT_QUALIFIED" },
        { name: "Expired", value: "EXPIRED" },
        { name: "Invite Bounced", value: "INVITE_BOUNCED" },
      ],
      screens: ["web", "tab", "mini_tab", "mob"],
    },
    {
      id: "created_at",
      name: "Invited on",
      type: "string",
      disableSorting: true,
      backendSorting: true,
      screens: ["web"],
      timeDifference: true,
    },
    {
      id: "updated_at",
      name: "Last Activity",
      type: "string",
      disableSorting: true,
      backendSorting: true,
      screens: ["web"],
      timeDifference: true,
    },

    {
      id: "hiringStage",
      name: "Hiring Stage",
      type: "string",
      disableSorting: true,
      enableFilter: true,
      filterName: "hiring_stage",
      filterOptions: [
        { name: "Not Yet Evaluated", value: "PENDING" },
        { name: "Rejected", value: "REJECTED" },
        { name: "Shortlisted", value: "SHORTLISTED" },
      ],
      screens: ["web", "tab"],
    },
  ];

  const OnOpenRightSideBartestTableHeader = [
    {
      id: "name",
      name: "Candidates",
      type: "string",
      disableSorting: true,
      screens: ["web", "tab", "mini_tab", "mob"],
    },

    {
      id: "hiringStage",
      name: "Hiring Stage",
      type: "string",
      disableSorting: true,
      enableFilter: true,
      filterName: "hiring_stage",
      filterOptions: [
        { name: "Not Yet Evaluated", value: "PENDING" },
        { name: "Rejected", value: "REJECTED" },
        { name: "Shortlisted", value: "SHORTLISTED" },
      ],
      screens: ["web", "tab", "mini_tab"],
    },
  ];

  const customSorting = {
    score: (a, b) => {
      const parseScore = (scoreString) => {
        if (scoreString === "N/A") {
          return 0;
        }
        return parseFloat(scoreString.replace("%", ""));
      };
      return parseScore(a) - parseScore(b);
    },
    created_at: (a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA - dateB;
    },
    updated_at: (a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);
      return dateA - dateB;
    },
  };

  const searchColumns = ["name", "email"];

  const handleRowSelect = (id, type, value) => {
    if (type === "single") {
      setCurr_assessment_spec({
        ...curr_assessment_spec,
        assessments: curr_assessment_spec?.assessments.map((assessment) =>
          id === assessment.id
            ? { ...assessment, selected: !assessment.selected }
            : assessment,
        ),
      });
    } else {
      setCurr_assessment_spec({
        ...curr_assessment_spec,
        assessments: curr_assessment_spec?.assessments.map((assessment, i) => {
          return id.includes(assessment.id)
            ? { ...assessment, selected: value }
            : { ...assessment };
        }),
      });
    }
  };

  const handleBulkUpdate = async (selectedIds, hiringStage, assessments) => {
    try {
      await dispatch(
        patchAssessmentHiringStage({
          data: {
            assess_ids: selectedIds,
            spec_id: curr_assessment_spec?.id,
            hiring_stage: hiringStage,
          },
        }),
      );
      setCurr_assessment_spec({
        ...assessSpec?.curr_assessment_spec,
        assessments: assessments,
      });
      setAlert(
        <AlertBox
          style={{ zIndex: "99999" }}
          color="success"
          description={"Bulk Hiring Stage Updated Successfully"}
          title="Success"
          isOpen={true}
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
      const selectedAssessment = assessments?.find(
        (assessment) => assessment.id === selectedRow?.id,
      );
      if (selectedAssessment) {
        setSelectedRow(selectedAssessment);
      }
    } catch (error) {
      setAlert(
        <AlertBox
          style={{ zIndex: "99999" }}
          color="danger"
          description={"Bulk Hiring Stage Update Failed"}
          title="Error"
          isOpen={true}
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
    }
  };

  useMemo(() => {
    if (!assessSpec?.curr_assessment_spec) return;

    const assessments = assessSpec?.curr_assessment_spec?.assessments?.map(
      (assessment) => {
        return { ...assessment };
      },
    );
    setCurr_assessment_spec({
      ...assessSpec?.curr_assessment_spec,
      assessments: assessments,
    });
  }, [assessSpec?.curr_assessment_spec]);

  useMemo(() => {
    if (assessSpec?.curr_assessment_spec === null) return;
    const _data = curr_assessment_spec?.assessments?.map(
      (assessment, index) => {
        return {
          name: (
            <div
              style={{ marginLeft: "24px", marginTop: "2px" }}
              className="d-flex align-items-baseline"
            >
              {" "}
              {assessment.user?.first_name || assessment.user?.last_name
                ? `${assessment.user?.first_name || ""}
					${assessment.user?.last_name || ""}`
                : `${assessment?.email || "-"}`}
            </div>
          ),
          createdAt: assessment.created_at,
          updatedAt: assessment.updated_at,
          candidatesStatus: (
            <div
              key="1"
              className="candidate-status-container body-2"
              style={{
                border:
                  assessment.status !== "FINISHED" ? "1px solid black" : "",
                background:
                  assessment.status === "FINISHED" ? "#7C21FF" : "#FFFFFF",
                color: assessment.status === "FINISHED" ? "#FFF" : "#121216",
              }}
            >
              {assessment.status === "PENDING"
                ? "Pending"
                : assessment.status === "IN_PROGRESS"
                  ? "In Progress"
                  : assessment.status === "NOT_QUALIFIED"
                    ? "Not Qualified"
                    : assessment.status === "DECLINED"
                      ? "Declined"
                      : assessment.status === "EXPIRED"
                        ? "EXPIRED"
                        : assessment.status === "INVITE_BOUNCED"
                          ? "Invite Bounced"
                          : "Completed"}
            </div>
          ),
          score: assessment.cum_score
            ? assessment.cum_score === null
              ? "N/A"
              : `${Math.round(assessment.cum_score * 100)}%`
            : assessment?.cum_score_obj
              ? `${parseFloat(
                  (10 / 1) * assessment?.cum_score_obj?.score,
                ).toFixed(1)}`
              : "N/A",
          ...assessment,
          hiringStage: `${
            assessment?.hiring_stage?.charAt(0).toUpperCase() +
            assessment?.hiring_stage?.toLowerCase()?.slice(1)
          }`,
          user: {
            name: `${assessment.user?.first_name || ""} ${
              assessment.user?.last_name || ""
            }`,
            email: assessment.email,
            ...assessment.user,
          },
        };
      },
    );
    setTestData(_data ? [..._data] : []);
  }, [curr_assessment_spec, curr_assessment_spec?.assessments]);

  useMemo(() => {
    if (assessSpec?.curr_assessment_spec === null) return;
    const _navOptions = [];
    curr_assessment_spec?.assessments?.length > 0 &&
      defaultFilterOptions.map((navOp) => {
        if (navOp?.value === "all") {
          return _navOptions.push({
            ...navOp,
            count: curr_assessment_spec?.assessments?.length || 0,
          });
        } else {
          return _navOptions.push({
            ...navOp,
            count:
              curr_assessment_spec?.assessments?.filter((_assess) => {
                return _assess.status === navOp?.value?.toUpperCase();
              }).length || 0,
          });
        }
      });
    setNavOptions(
      _navOptions.length > 0 ? [..._navOptions] : [...defaultFilterOptions],
    );
  }, [curr_assessment_spec]);

  const onUpdateSharedPublicly = (shared_publicly) => {
    if (assessSpec?.curr_assessment_spec === null) return;
    var _assessments = curr_assessment_spec?.assessments;
    let _assessment =
      _assessments.filter((_assess) => {
        return _assess?.id === selectedRow?.id;
      })[0] || selectedRow;
    _assessment = {
      ..._assessment,
      shared_publicly: shared_publicly,
    };
    _assessments = _assessments.map((item) => {
      return item.id == selectedRow.id ? _assessment : item;
    });
    setSelectedRow(_assessment);
    setCurr_assessment_spec({
      ...curr_assessment_spec,
      assessments: _assessments,
    });
  };

  const onHiringStageUpdate = (hiringStage) => {
    if (assessSpec?.curr_assessment_spec === null) return;
    var _assessments = curr_assessment_spec?.assessments;
    let _assessment =
      _assessments.filter((_assess) => {
        return _assess?.id === selectedRow?.id;
      })[0] || selectedRow;
    _assessment = {
      ..._assessment,
      hiring_stage: hiringStage,
      hiringStage: hiringStage,
    };
    _assessments = _assessments.map((item) => {
      return item.id == selectedRow.id ? _assessment : item;
    });
    setSelectedRow(_assessment);
    setCurr_assessment_spec({
      ...curr_assessment_spec,
      assessments: _assessments,
    });
  };

  const viewCriteria = async () => {
    history.push(`${PathName.ASSESSMENTS}/criteria/${params.id}`);
  };

  const publishAssessment = async () => {
    history.push({
      pathname: `${PathName.ASSESSMENTS}/publish/${params.id}`,
      state: { fromDetails: true },
    });
  };

  const copyLink = async (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(
      `${window.location.origin}/?invite_id=${assessSpec?.curr_assessment_spec?.invite_id}`,
    );
    setAlert(
      <AlertBox
        style={{ zIndex: "99999" }}
        color="success"
        description={`${assessSpec?.curr_assessment_spec?.title} assessment invite link copied successfully!`}
        title="Success"
        isOpen={true}
        onCloseAlert={() => {
          setAlert(null);
        }}
      />,
    );
  };

  const cloneAssessment = async () => {
    const res = await dispatch(cloneAssessSpec({ id: params.id }));
    if (res?.meta?.requestStatus === RequestStatus.REJECTED) {
      setAlert(
        <AlertBox
          style={{ zIndex: "99999" }}
          color="danger"
          description={res?.payload}
          title="Error"
          isOpen={true}
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
    } else {
      setAlert(
        <AlertBox
          style={{ zIndex: "99999" }}
          color="success"
          description={`${assessSpec?.curr_assessment_spec?.title} cloned successfully!`}
          title="Success"
          isOpen={true}
          onCloseAlert={() => {
            setAlert(null);
          }}
        />,
      );
      history.push(`${PathName.ASSESSMENTS}/create/${res?.payload?.data?.id}`);
    }
  };

  const editAssessment = async () => {
    history.push(`${PathName.ASSESSMENTS}/create/${params.id}`);
  };

  useEffect(() => {
    dispatch(
      getAssessSpec({
        id: params.id,
        query: "?expand=assessments",
        page: currentPage,
        limit: itemsPerPage,
        status: selectedStatus,
        hiring_stage: selectedHiringStage,
        search: selectedSearch,
        sort_by: selectedSortBy || "",
        sort_direction: selectedSortOrder || "",
      }),
    );
    setIsReady(true);
    return () => {
      setIsRightMenuOpen(false);
      setCommonValues({
        ...commonValues,
        isSideBarExpanded: true,
        detailedTestView: { isExpanded: false, testType: null, data: null },
      });
    };
  }, [
    currentPage,
    itemsPerPage,
    selectedStatus,
    selectedHiringStage,
    selectedSearch,
    selectedSortBy,
    selectedSortOrder,
  ]);

  useEffect(() => {
    if (assessSpec?.assessments_total !== undefined && itemsPerPage) {
      const maxPage =
        Math.ceil(assessSpec.assessments_total / itemsPerPage) || 1;
      if (currentPage > maxPage) {
        setCurrentPage(maxPage);
      }
    }
  }, [assessSpec?.assessments_total, itemsPerPage, currentPage]);

  useEffect(() => {
    setSelectedsortOption((prev) => ({
      ...prev,
      column: selectedSortColumn || null,
      order: ["ASC", "DESC"].includes(selectedSortOrder)
        ? selectedSortOrder
        : "none",
    }));
  }, [selectedSortColumn, selectedSortOrder]);

  const isCurrentSpecLoaded =
    String(curr_assessment_spec?.id) === String(params?.id);
  const hasTableDataForCurrentSpec =
    isCurrentSpecLoaded && Array.isArray(curr_assessment_spec?.assessments);
  const isTableDataRefreshing =
    assessSpec?.loading || !hasTableDataForCurrentSpec;

  if (!isReady || (!isCurrentSpecLoaded && assessSpec?.loading)) {
    return (
      <div
        className="d-flex align-items-center justify-comtent-center"
        style={{
          width: isOnMobileScreen ? "100vw" : "calc(100vw - 40px)",
          height: "100vh",
        }}
      >
        <ProcessingIndicator className="medium-indicator" />
      </div>
    );
  }

  const handleGoBack = () => {
    assessSpec?.curr_assessment_spec?.status === "ACTIVE"
      ? history.push(`${PathName.ASSESSMENTS}`)
      : history.push(`${PathName.ASSESSMENTS}/archived`); // Push to the PathName.ASSESSMENTS route
  };

  const MinimizeViewBar = () => {
    return (
      <div
        className={"collapsed-left-sidebar-container pointer"}
        onClick={() => {
          setCommonValues({
            ...commonValues,
            detailedTestView: {
              isExpanded: false,
              testType: null,
              data: null,
            },
          });
          (isOnTabletScreen || isOnMobileScreen) && setIsRightMenuOpen(false);
        }}
      >
        {isOnMobileScreen && (
          <span className="subtitle-1 sidebar-container-headline">
            {assessSpec?.curr_assessment_spec?.title}
          </span>
        )}
        <MinimizeIcon
          style={{
            width: isOnMobileScreen ? "34" : "44px",
            height: isOnMobileScreen ? "34" : "44px",
          }}
        />
        {!isOnMobileScreen && (
          <span className="headline-3 sidebar-container-headline">
            {assessSpec?.curr_assessment_spec?.title}
          </span>
        )}
      </div>
    );
  };

  return (
    <>
      {alert}
      {
        <>
          <CustomModal
            open={deleteAssessmentModal.isOpen}
            varrient="alert-warning-modal"
            processing={assessSpec?.processing}
            title={`Delete Assessment`}
            description={"Are you sure you want to delete this assessment?"}
            dangerAlert={true}
            handleCloseModal={() => {
              setDeleteAssessmentModal({ isOpen: false });
            }}
            confirmBtnTitle={"Delete"}
            onConfirm={async () => {
              await dispatch(
                deleteAssessSpec({
                  data: assessSpec?.curr_assessment_spec,
                  id: assessSpec?.curr_assessment_spec?.id,
                }),
              );
              setDeleteAssessmentModal({ isOpen: false });
              {
                assessSpec?.curr_assessment_spec?.status === "ACTIVE"
                  ? history.push(`${PathName.ASSESSMENTS}`)
                  : history.push(`${PathName.ASSESSMENTS}/archived`);
              }
            }}
          />
          <CustomModal
            open={archiveAssessmentModal.isOpen}
            varrient="alert-warning-modal"
            processing={assessSpec?.processing}
            title={`Archive Assessment`}
            description={"Are you sure you want to archive this assessment?"}
            dangerAlert={true}
            handleCloseModal={() => {
              setArchiveAssessmentModal({ isOpen: false });
            }}
            confirmBtnTitle={"Archive"}
            onConfirm={async () => {
              await dispatch(
                archiveAssessSpec({
                  data: assessSpec?.curr_assessment_spec,
                  id: assessSpec?.curr_assessment_spec?.id,
                }),
              );
              setArchiveAssessmentModal({ isOpen: false });
              {
                assessSpec?.curr_assessment_spec?.status === "ACTIVE"
                  ? history.push(`${PathName.ASSESSMENTS}`)
                  : history.push(`${PathName.ASSESSMENTS}/archived`);
              }
            }}
          />
        </>
      }
      {isOnWebScreen ? (
        <>
          <div
            className="view-with-sidebar"
            style={
              commonValues.detailedTestView.isExpanded
                ? {
                    justifyContent: "flex-start",
                    gap: "24px",
                    overflow: "hidden",
                  }
                : { overflow: "hidden" }
            }
          >
            {commonValues.detailedTestView.isExpanded ? (
              <MinimizeViewBar />
            ) : (
              <div
                className={`left-sidebar-container ${
                  isRightMenuOpen && " left-sidebar-open "
                }`}
              >
                <div
                  className="test-detail-container w-100 d-flex flex-column align-items-start hide-scrollbar"
                  style={{ height: "calc(100vh - 49px)", overflowY: "auto" }}
                >
                  <div
                    className={`test-detail-header w-100 d-flex flex-row justify-content-between mb-3 ${
                      isRightMenuOpen && " test-detail-header"
                    }`}
                    style={{ height: isRightMenuOpen ? "214px" : "144px" }}
                  >
                    <div className="test-detail-header-left w-100 d-flex flex-column">
                      <div className=" d-flex justify-content-between">
                        <div
                          style={{
                            height: "44px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "16px",
                          }}
                        >
                          <div className="icon-cover" onClick={handleGoBack}>
                            <LeftArrowIcon />
                          </div>
                          <span
                            className="body-2 "
                            style={{ color: "#808191" }}
                          >
                            {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE"
                              ? "Active Assessments"
                              : "Archive Assessments"}
                          </span>
                        </div>
                        <div
                          className=" justify-content-between align-items-center"
                          style={{
                            gap: "8px",
                            display: "flex",
                          }}
                        >
                          {/* <CustomTooltip
                            position="top-end"
                            text="View Assessment Criteria"
                          >
                            <div
                              className="icon-cover"
                              onClick={() => {
                                viewCriteria();
                              }}
                            >
                              <FileIcon />
                            </div>
                          </CustomTooltip> */}
                          {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE" &&
                            auth.data.role.name !== "Member" && (
                              <CustomTooltip
                                position="top-end"
                                text="View & Edit Assessment"
                              >
                                <div
                                  className="icon-cover"
                                  onClick={() => {
                                    editAssessment();
                                  }}
                                >
                                  <EditIcon />
                                </div>
                              </CustomTooltip>
                            )}
                          {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE" &&
                            auth.data.role.name !== "Member" && (
                              <>
                                <CustomTooltip
                                  position="top-end"
                                  text={"Copy Invite Link"}
                                >
                                  <div
                                    className="icon-cover"
                                    onClick={(e) => {
                                      copyLink(e);
                                    }}
                                  >
                                    <LinkIcon stroke={"#808191"} />
                                  </div>
                                </CustomTooltip>
                                <CustomTooltip
                                  position="top-end"
                                  text="Archive Assessment"
                                >
                                  <div
                                    className="icon-cover"
                                    onClick={() => {
                                      setArchiveAssessmentModal({
                                        isOpen: true,
                                      });
                                    }}
                                  >
                                    <ArchiveIcon stroke={"#808191"} />
                                  </div>
                                </CustomTooltip>
                              </>
                            )}
                          {auth.data.role.name !== "Member" && (
                            <CustomTooltip
                              position="top-end"
                              text="Clone Assessment"
                            >
                              <div
                                className="icon-cover"
                                onClick={() => {
                                  cloneAssessment();
                                }}
                              >
                                <CopyIcon />
                              </div>
                            </CustomTooltip>
                          )}
                          {assessSpec?.curr_assessment_spec?.assessments
                            ?.length <= 0 &&
                            auth.data.role.name !== "Member" && (
                              <CustomTooltip
                                position="top-end"
                                text="Delete Assessment"
                              >
                                <div
                                  className="icon-cover"
                                  onClick={() => {
                                    setDeleteAssessmentModal({ isOpen: true });
                                  }}
                                >
                                  <TrashIcon />
                                </div>
                              </CustomTooltip>
                            )}
                          {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE" &&
                            auth.data.role.name !== "Member" && (
                              <div
                                style={{
                                  width:
                                    isRightMenuOpen && isOnSmallWebScreen
                                      ? "44px"
                                      : "157px",
                                }}
                              >
                                {isRightMenuOpen && isOnSmallWebScreen ? (
                                  <CustomTooltip
                                    position="top-end"
                                    text="Invite Candidates"
                                  >
                                    <div
                                      className="icon-cover d-flex align-items-center justify-content-center"
                                      style={{
                                        height: "44px",
                                        width: "44px",
                                        background: "#121216",
                                        borderRadius: "50px",
                                      }}
                                      onClick={() => {
                                        publishAssessment();
                                      }}
                                    >
                                      <ShareIcon />
                                    </div>
                                  </CustomTooltip>
                                ) : (
                                  <Button
                                    btn="ragular-btn"
                                    varrient="primary"
                                    title={"Invite Candidates"}
                                    onClick={() => {
                                      publishAssessment();
                                    }}
                                  />
                                )}
                              </div>
                            )}
                        </div>
                      </div>
                      {/* <GetAvtarImage
												className='assessment-upload-icon pointer'
												src={{
													image_id: assessSpec?.curr_assessment_spec?.avatar_id,
													name: assessSpec?.curr_assessment_spec?.title,
												}}
												size='custom'
												width={72}
												height={72}
											/> */}
                      <div className="d-flex justify-content-between">
                        <div
                          className="w-100 d-flex justify-content-between"
                          style={{
                            gap: "8px",
                            flexDirection: isRightMenuOpen ? "column" : "row",
                          }}
                        >
                          <div
                            className="w-100 d-flex justify-content-between"
                            style={{
                              gap: "8px",
                              flexDirection: isRightMenuOpen ? "column" : "row",
                            }}
                          >
                            <span
                              className="headline-3 text-start"
                              style={{
                                maxWidth: "auto",
                                wordBreak: "break-all",
                                overflow: "hidden",
                                display: "inline-block",
                                verticalAlign: "middle",
                                color: "#2B3340",
                              }}
                            >
                              {assessSpec?.curr_assessment_spec?.title}
                            </span>
                            <div
                              className="d-flex"
                              style={{
                                gap: isRightMenuOpen ? "6px" : "24px",
                                flexDirection: isRightMenuOpen
                                  ? "column"
                                  : "row",
                                alignItems: isRightMenuOpen
                                  ? "start"
                                  : "center",
                              }}
                            >
                              {assessSpec?.curr_assessment_spec?.author && (
                                <div
                                  className="d-flex flex-row align-items-center justify-content-center"
                                  style={{ gap: "6px" }}
                                >
                                  <ProfilePic
                                    height={"16px"}
                                    width={"16px"}
                                    stroke={"#96999C"}
                                  />
                                  <span className="body-2 black-500">
                                    {"Created By "}
                                    <span
                                      className="body-2"
                                      style={{
                                        color: "#121216",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {assessSpec?.curr_assessment_spec?.author
                                        ?.first_name +
                                        " " +
                                        assessSpec?.curr_assessment_spec?.author
                                          ?.last_name}
                                    </span>
                                  </span>
                                </div>
                              )}
                              <div
                                className="d-flex flex-row align-items-center"
                                style={{ gap: "6px" }}
                              >
                                <CreatedIcon />
                                <span className="body-2 black-500">
                                  {"Created on "}
                                  <span
                                    className="body-2"
                                    style={{
                                      color: "#121216",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {DateToMMDDYYYY(
                                      assessSpec?.curr_assessment_spec
                                        ?.created_at,
                                    )}
                                  </span>
                                </span>
                              </div>
                              <div
                                className="d-flex flex-row align-items-center"
                                style={{ gap: "6px" }}
                              >
                                <img src={LastActivity} alt="" />
                                <span className="body-2 black-500">
                                  {"Last Activity "}
                                  <span
                                    className="body-2"
                                    style={{
                                      color: "#121216",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {localTimeDifference(
                                      assessSpec?.curr_assessment_spec
                                        ?.candidate_last_activity ??
                                        assessSpec?.curr_assessment_spec
                                          ?.updated_at,
                                    )}{" "}
                                  </span>
                                </span>
                                <CustomTooltip
                                  position="top-start"
                                  text={`on ${formatDate(
                                    assessSpec?.curr_assessment_spec
                                      ?.candidate_last_activity ??
                                      assessSpec?.curr_assessment_spec
                                        ?.updated_at,
                                  ).replace("at", "/")}`}
                                >
                                  <InfoIcon
                                    style={{
                                      width: "16px",
                                      height: "16px",
                                      stroke: "#121216",
                                    }}
                                  />
                                </CustomTooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="test-detail-assessments-stats-container mb-3">
                    <div className="assessments-stats">
                      <div
                        className={`assessments-stats-card ${
                          isRightMenuOpen ? "candidate-assess-stats-card" : ""
                        }`}
                        style={isRightMenuOpen ? { width: "22%" } : {}}
                      >
                        <div className="stats-card-text">
                          <div
                            style={{
                              position: "relative",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <CustomTooltip
                              customPosition={{ bottom: "42px", right: "5px" }}
                              text={"Assessment Duration"}
                            >
                              <span
                                className="body-2  dark-50"
                                style={{
                                  color: "#808191",
                                  display: isRightMenuOpen ? "none" : "block",
                                }}
                              >
                                Total
                              </span>
                            </CustomTooltip>
                            <CustomTooltip
                              customPosition={{ bottom: "12px", left: "8px" }}
                              text={
                                assessSpec?.curr_assessment_spec
                                  ?.objective_test_duration !== undefined ||
                                assessSpec?.curr_assessment_spec
                                  ?.objective_test_duration !== null
                                  ? "This cumulative duration applies to objective tests (skill, coding, value fitness). Text and Case Study tests have flexible time (hours to days), while Video and Upload tests are without set time limits."
                                  : "This is the cumulative duration for all test types including Case Study and Text Responses"
                              }
                            >
                              <InfoIcon
                                style={{
                                  position: "absolute",
                                  right: "0px",
                                  bottom: "4px",
                                  width: "14px",
                                  height: "14px",
                                  stroke: "#808191",
                                  display: isRightMenuOpen ? "none" : "block",
                                }}
                              />
                            </CustomTooltip>
                          </div>
                          <span
                            className={`headline-5 dark-100 ${
                              isRightMenuOpen ? "body-2" : ""
                            }`}
                          >
                            {secondsTohhmm(
                              assessSpec?.curr_assessment_spec
                                ?.objective_test_duration ||
                                assessSpec?.curr_assessment_spec?.duration ||
                                0,
                            )}
                          </span>
                        </div>
                        <div className="AssessmentsStatsIcon-container">
                          <TimeStatsIcon className="AssessmentsStatsIcon" />
                        </div>
                      </div>
                      <div
                        className={`assessments-stats-card ${
                          isRightMenuOpen ? "candidate-assess-stats-card" : ""
                        }`}
                        style={isRightMenuOpen ? { width: "22%" } : {}}
                      >
                        <div className="stats-card-text">
                          <span
                            className="body-2 dark-50"
                            style={{
                              color: "#808191",
                              display: isRightMenuOpen ? "none" : "block",
                            }}
                          >
                            Expiry
                          </span>
                          <span
                            className={`headline-5 dark-100 ${
                              isRightMenuOpen ? "body-2" : ""
                            }`}
                          >
                            {assessSpec?.curr_assessment_spec?.deadline
                              ? `In ${
                                  assessSpec?.curr_assessment_spec?.deadline /
                                  86400
                                } Days`
                              : "None"}
                          </span>
                        </div>
                        <div className="AssessmentsStatsIcon-container">
                          <ExpiryStatsIcon className="AssessmentsStatsIcon" />
                        </div>
                      </div>
                      <div
                        className={`assessments-stats-card ${
                          isRightMenuOpen ? "candidate-assess-stats-card" : ""
                        }`}
                        style={isRightMenuOpen ? { width: "22%" } : {}}
                      >
                        <div className="stats-card-text">
                          <span
                            className="body-2  dark-50"
                            style={{
                              color: "#808191",
                              display: isRightMenuOpen ? "none" : "block",
                            }}
                          >
                            Invites Sent
                          </span>
                          <span
                            className={`headline-5 dark-100 ${
                              isRightMenuOpen ? "body-2" : ""
                            }`}
                          >
                            {/* {assesment?.invited || 0} */}
                            {assessSpec?.assessments_total || 0}
                          </span>
                        </div>
                        <div className="AssessmentsStatsIcon-container">
                          <InvitedStatsIcon className="AssessmentsStatsIcon" />
                        </div>
                      </div>
                      <div
                        className={`assessments-stats-card ${
                          isRightMenuOpen ? "candidate-assess-stats-card" : ""
                        }`}
                        style={isRightMenuOpen ? { width: "22%" } : {}}
                      >
                        <div className="stats-card-text">
                          <span
                            className="body-2  dark-50"
                            style={{
                              color: "#808191",
                              display: isRightMenuOpen ? "none" : "block",
                            }}
                          >
                            Evaluations
                          </span>
                          <span
                            className={`headline-5 dark-100 ${
                              isRightMenuOpen ? "body-2" : ""
                            }`}
                          >
                            {/* {assesment?.completed || 0} */}
                            {completedAssessment?.length || 0}
                          </span>
                        </div>
                        <div className="AssessmentsStatsIcon-container">
                          <AttemptsStatsIcon className="AssessmentsStatsIcon" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "24px",
                      width: "100%",
                    }}
                  >
                    <div className="candidate-details-container">
                      <div
                        className="w-100"
                        style={{
                          height: "calc(100vh - 325px)",
                          borderRadius: "24px",
                          background: "white",
                        }}
                      >
                        <Table
                          headers={
                            isRightMenuOpen
                              ? OnOpenRightSideBartestTableHeader
                              : testTableHeader
                          }
                          data={isTableDataRefreshing ? [] : testData}
                          setData={setTestData}
                          onSelectRow={(row) => {
                            setIsRightMenuOpen(true);
                            setCommonValues({
                              ...commonValues,
                              isSideBarExpanded: false,
                            });
                            setSelectedRow(row);
                          }}
                          searchColumns={searchColumns}
                          // disableSearchInput={true}
                          customSorting={customSorting}
                          isRightMenuOpen={isRightMenuOpen}
                          enableCheckbox={true}
                          highlightActiveRow={highlightActiveRow}
                          setHighlightActiveRow={setHighlightActiveRow}
                          testDetails={true}
                          customSearch={false}
                          handleBulkUpdate={handleBulkUpdate}
                          nullTableTitle={"No Assessments to show"}
                          nullTableDescription={`Try adjusting your search query or filters`}
                          nullTableLoading={isTableDataRefreshing}
                          setSelectedsortOption={setSelectedsortOption}
                          selectedsortOption={selectedsortOption}
                          handleRowSelect={handleRowSelect}
                          onRowsPerPageChange={handleRowsPerPageChange}
                          selectedId={selectedRow?.id}
                          itemsPerPage={itemsPerPage}
                          backendFilter={true}
                          currentPage={currentPage}
                          totalItems={assessSpec?.assessments_total || 0}
                          totalPages={
                            Math.ceil(
                              (assessSpec?.assessments_total || 0) /
                                itemsPerPage,
                            ) || 1
                          }
                          nextSlide={() => setCurrentPage((p) => p + 1)}
                          prevSlide={() =>
                            setCurrentPage((p) => Math.max(1, p - 1))
                          }
                        ></Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              className={`right-sidebar-container hide-scrollbar
									${isRightMenuOpen && " test-details-right-sidebar-open "}
									${
                    commonValues.detailedTestView.isExpanded &&
                    " test-details-right-sidebar-open-minimized "
                  }`}
            >
              <TestDetailsRightView
                onClose={handleClose}
                assessment={selectedRow}
                onUpdateSharedPublicly={onUpdateSharedPublicly}
                onHiringStageUpdate={onHiringStageUpdate}
                assessmentsLength={transformedData.length}
                selectedIndex={transformedData.findIndex(
                  (test) => test.id === selectedRow?.id,
                )}
                onSwitchAssessment={(next = false) => {
                  const currentIndex = transformedData.findIndex(
                    (test) => test.id === selectedRow?.id,
                  );
                  if (currentIndex !== -1) {
                    if (next && transformedData[currentIndex + 1]) {
                      setSelectedRow(transformedData[currentIndex + 1]);
                    } else if (transformedData[currentIndex - 1]) {
                      setSelectedRow(transformedData[currentIndex - 1]);
                    }
                  }
                }}
              />
            </div>
            <TestDetailedView assessment={selectedRow} />
          </div>
        </>
      ) : isOnTabletScreen ? (
        <>
          <div className="view-with-sidebar">
            {isRightMenuOpen ? (
              <MinimizeViewBar />
            ) : (
              <div
                className="test-detail-container hide-scrollbar"
                style={{ height: "calc(100vh - 49px)" }}
              >
                <div
                  className={`test-detail-header w-100 d-flex flex-row justify-content-between mb-3 ${
                    isRightMenuOpen && " test-detail-header"
                  }`}
                  style={{ height: "214px" }}
                >
                  <div className="test-detail-header-left w-100 d-flex flex-column">
                    <div className=" d-flex justify-content-between">
                      <div
                        style={{
                          height: "44px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "16px",
                        }}
                      >
                        <div className="icon-cover" onClick={handleGoBack}>
                          <LeftArrowIcon />
                        </div>
                        <span className="body-2 " style={{ color: "#808191" }}>
                          {assessSpec?.curr_assessment_spec?.status === "ACTIVE"
                            ? "Active Assessments"
                            : "Archive Assessments"}
                        </span>
                      </div>
                      <div
                        className=" justify-content-between align-items-center"
                        style={{
                          gap: "8px",
                          display: isRightMenuOpen ? "none" : "flex",
                        }}
                      >
                        {/* <CustomTooltip
                          position="top-end"
                          text="View Assessment Criteria"
                        >
                          <div
                            className="icon-cover"
                            onClick={() => {
                              viewCriteria();
                            }}
                          >
                            <FileIcon />
                          </div>
                        </CustomTooltip> */}
                        {assessSpec?.curr_assessment_spec?.status ===
                          "ACTIVE" &&
                          auth.data.role.name !== "Member" && (
                            <CustomTooltip
                              position="top-end"
                              text="View & Edit Assessment"
                            >
                              <div
                                className="icon-cover"
                                onClick={() => {
                                  editAssessment();
                                }}
                              >
                                <EditIcon />
                              </div>
                            </CustomTooltip>
                          )}
                        {assessSpec?.curr_assessment_spec?.status ===
                          "ACTIVE" &&
                          auth.data.role.name !== "Member" && (
                            <>
                              <CustomTooltip
                                position="top-end"
                                text={"Copy Invite Link"}
                              >
                                <div
                                  className="icon-cover"
                                  onClick={(e) => {
                                    copyLink(e);
                                  }}
                                >
                                  <LinkIcon stroke={"#808191"} />
                                </div>
                              </CustomTooltip>
                              <CustomTooltip
                                position="top-end"
                                text="Archive Assessment"
                              >
                                <div
                                  className="icon-cover"
                                  onClick={() => {
                                    setArchiveAssessmentModal({
                                      isOpen: true,
                                    });
                                  }}
                                >
                                  <ArchiveIcon stroke={"#808191"} />
                                </div>
                              </CustomTooltip>
                            </>
                          )}
                        {auth.data.role.name !== "Member" && (
                          <CustomTooltip
                            position="top-end"
                            text="Clone Assessment"
                          >
                            <div
                              className="icon-cover"
                              onClick={() => {
                                cloneAssessment();
                              }}
                            >
                              <CopyIcon />
                            </div>
                          </CustomTooltip>
                        )}
                        {assessSpec?.curr_assessment_spec?.assessments
                          ?.length <= 0 &&
                          auth.data.role.name !== "Member" && (
                            <CustomTooltip
                              position="top-end"
                              text="Delete Assessment"
                            >
                              <div
                                className="icon-cover"
                                onClick={() => {
                                  setDeleteAssessmentModal({ isOpen: true });
                                }}
                              >
                                <TrashIcon />
                              </div>
                            </CustomTooltip>
                          )}
                        {assessSpec?.curr_assessment_spec?.status ===
                          "ACTIVE" &&
                          auth.data.role.name !== "Member" && (
                            <div style={{ width: "157px" }}>
                              <Button
                                btn="ragular-btn"
                                varrient="primary"
                                title={"Invite Candidates"}
                                onClick={() => {
                                  publishAssessment();
                                }}
                              />
                            </div>
                          )}
                      </div>
                    </div>
                    {/* <GetAvtarImage
												className='assessment-upload-icon pointer'
												src={{
													image_id: assessSpec?.curr_assessment_spec?.avatar_id,
													name: assessSpec?.curr_assessment_spec?.title,
												}}
												size='custom'
												width={72}
												height={72}
											/> */}
                    <div
                      className="w-100 d-flex align-items-start"
                      style={{
                        gap: "8px",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        className="headline-3 text-start"
                        style={{
                          maxWidth: "auto",
                          wordBreak: "break-all",
                          overflow: "hidden",
                          display: "inline-block",
                          verticalAlign: "middle",
                          color: "#2B3340",
                        }}
                      >
                        {assessSpec?.curr_assessment_spec?.title}
                      </span>
                      {assessSpec?.curr_assessment_spec?.author && (
                        <div
                          className="d-flex flex-row align-items-center"
                          style={{ gap: "6px" }}
                        >
                          <ProfilePic
                            height={"16px"}
                            width={"16px"}
                            stroke={"#96999C"}
                          />

                          <span className="body-2 black-500">
                            {"Created By "}
                            <span
                              className="body-2"
                              style={{
                                color: "#121216",
                                fontWeight: "500",
                              }}
                            >
                              {assessSpec?.curr_assessment_spec?.author
                                ?.first_name +
                                " " +
                                assessSpec?.curr_assessment_spec?.author
                                  ?.last_name}
                            </span>
                          </span>
                        </div>
                      )}
                      <div
                        className="d-flex flex-row align-items-center"
                        style={{ gap: "6px" }}
                      >
                        <CreatedIcon />
                        <span className="body-2 black-500">
                          {"Created on "}
                          <span
                            className="body-2"
                            style={{
                              color: "#121216",
                              fontWeight: "500",
                            }}
                          >
                            {DateToMMDDYYYY(
                              assessSpec?.curr_assessment_spec?.created_at,
                            )}
                          </span>
                        </span>
                      </div>
                      <div
                        className="d-flex flex-row align-items-center"
                        style={{ gap: "6px" }}
                      >
                        <img src={LastActivity} alt="" />
                        <span className="body-2 black-500">
                          {"Last Activity "}
                          <span
                            className="body-2"
                            style={{
                              color: "#121216",
                              fontWeight: "500",
                            }}
                          >
                            {localTimeDifference(
                              assessSpec?.curr_assessment_spec
                                ?.candidate_last_activity ??
                                assessSpec?.curr_assessment_spec?.updated_at,
                            )}{" "}
                          </span>
                        </span>
                        <CustomTooltip
                          position="top-start"
                          text={`on ${formatDate(
                            assessSpec?.curr_assessment_spec
                              ?.candidate_last_activity ??
                              assessSpec?.curr_assessment_spec?.updated_at,
                          ).replace("at", "/")}`}
                        >
                          <InfoIcon
                            style={{
                              width: "16px",
                              height: "16px",
                              stroke: "#121216",
                            }}
                          />
                        </CustomTooltip>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="test-detail-assessments-stats-container mb-3">
                  <div className="assessments-stats">
                    <div
                      className={`assessments-stats-card ${
                        isRightMenuOpen ? "candidate-assess-stats-card" : ""
                      }`}
                      style={
                        isRightMenuOpen ? { width: "22.5%", gap: "1.5em" } : {}
                      }
                    >
                      <div className="stats-card-text">
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <CustomTooltip
                            customPosition={{ bottom: "42px", right: "5px" }}
                            text={"Assessment Duration"}
                          >
                            <span
                              className="body-2  dark-50"
                              style={{
                                color: "#808191",
                                display: isRightMenuOpen ? "none" : "block",
                              }}
                            >
                              Total
                            </span>
                          </CustomTooltip>

                          <CustomTooltip
                            customPosition={{ bottom: "12px", left: "8px" }}
                            text={
                              assessSpec?.curr_assessment_spec
                                ?.objective_test_duration !== undefined ||
                              assessSpec?.curr_assessment_spec
                                ?.objective_test_duration !== null
                                ? "This cumulative duration applies to objective tests (skill, coding, value fitness). Text and Case Study tests have flexible time (hours to days), while Video and Upload tests are without set time limits."
                                : "This is the cumulative duration for all test types including Case Study and Text Responses"
                            }
                          >
                            <InfoIcon
                              style={{
                                position: "absolute",
                                right: "0px",
                                bottom: "4px",
                                width: "14px",
                                height: "14px",
                                stroke: "#808191",
                                display: isRightMenuOpen ? "none" : "block",
                              }}
                            />
                          </CustomTooltip>
                        </div>
                        <span
                          className={`headline-5 dark-100 ${
                            isRightMenuOpen ? "body-2" : ""
                          }`}
                        >
                          {secondsTohhmm(
                            assessSpec?.curr_assessment_spec
                              ?.objective_test_duration ||
                              assessSpec?.curr_assessment_spec?.duration ||
                              0,
                          )}
                        </span>
                      </div>
                      <div className="AssessmentsStatsIcon-container">
                        <TimeStatsIcon className="AssessmentsStatsIcon" />
                      </div>
                    </div>
                    <div
                      className={`assessments-stats-card ${
                        isRightMenuOpen ? "candidate-assess-stats-card" : ""
                      }`}
                      style={
                        isRightMenuOpen ? { width: "22.5%", gap: "1.5em" } : {}
                      }
                    >
                      <div className="stats-card-text">
                        <span
                          className="body-2 dark-50"
                          style={{
                            color: "#808191",
                            display: isRightMenuOpen ? "none" : "block",
                          }}
                        >
                          Expiry
                        </span>
                        <span
                          className={`headline-5 dark-100 ${
                            isRightMenuOpen ? "body-2" : ""
                          }`}
                        >
                          {assessSpec?.curr_assessment_spec?.deadline
                            ? `In ${
                                assessSpec?.curr_assessment_spec?.deadline /
                                86400
                              } Days`
                            : "None"}
                        </span>
                      </div>
                      <div className="AssessmentsStatsIcon-container">
                        <ExpiryStatsIcon className="AssessmentsStatsIcon" />
                      </div>
                    </div>
                    <div
                      className={`assessments-stats-card ${
                        isRightMenuOpen ? "candidate-assess-stats-card" : ""
                      }`}
                      style={
                        isRightMenuOpen ? { width: "22.5%", gap: "1.5em" } : {}
                      }
                    >
                      <div className="stats-card-text">
                        <span
                          className="body-2  dark-50"
                          style={{
                            color: "#808191",
                            display: isRightMenuOpen ? "none" : "block",
                          }}
                        >
                          Invites Sent
                        </span>
                        <span
                          className={`headline-5 dark-100 ${
                            isRightMenuOpen ? "body-2" : ""
                          }`}
                        >
                          {/* {assesment?.invited || 0} */}
                          {assessSpec?.assessments_total || 0}
                        </span>
                      </div>
                      <div className="AssessmentsStatsIcon-container">
                        <InvitedStatsIcon className="AssessmentsStatsIcon" />
                      </div>
                    </div>
                    <div
                      className={`assessments-stats-card ${
                        isRightMenuOpen ? "candidate-assess-stats-card" : ""
                      }`}
                      style={
                        isRightMenuOpen ? { width: "22.5%", gap: "1.5em" } : {}
                      }
                    >
                      <div className="stats-card-text">
                        <span
                          className="body-2  dark-50"
                          style={{
                            color: "#808191",
                            display: isRightMenuOpen ? "none" : "block",
                          }}
                        >
                          Evaluations
                        </span>
                        <span
                          className={`headline-5 dark-100 ${
                            isRightMenuOpen ? "body-2" : ""
                          }`}
                        >
                          {/* {assesment?.completed || 0} */}
                          {completedAssessment?.length || 0}
                        </span>
                      </div>
                      <div className="AssessmentsStatsIcon-container">
                        <AttemptsStatsIcon className="AssessmentsStatsIcon" />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ background: "white", borderRadius: "24px" }}>
                  <div className="candidate-details-container">
                    <div
                      className="w-100"
                      style={{
                        height: "calc(100vh - 325px)",
                        borderRadius: "24px",
                        background: "white",
                      }}
                    >
                      <Table
                        headers={
                          isRightMenuOpen
                            ? OnOpenRightSideBartestTableHeader
                            : testTableHeader
                        }
                        data={isTableDataRefreshing ? [] : testData}
                        setData={setTestData}
                        isRightMenuOpen={isRightMenuOpen}
                        onSelectRow={(row) => {
                          setIsRightMenuOpen(true);
                          setCommonValues({
                            ...commonValues,
                            isSideBarExpanded: false,
                          });
                          setSelectedRow(row);
                        }}
                        searchColumns={searchColumns}
                        // disableSearchInput={true}
                        customSorting={customSorting}
                        enableCheckbox={true}
                        highlightActiveRow={highlightActiveRow}
                        setHighlightActiveRow={setHighlightActiveRow}
                        testDetails={true}
                        customSearch={false}
                        handleBulkUpdate={handleBulkUpdate}
                        nullTableTitle={"No Assessments to show"}
                        nullTableDescription={`Try adjusting your search query or filters`}
                        nullTableLoading={isTableDataRefreshing}
                        setSelectedsortOption={setSelectedsortOption}
                        selectedsortOption={selectedsortOption}
                        handleRowSelect={handleRowSelect}
                        selectedId={selectedRow?.id}
                        onRowsPerPageChange={handleRowsPerPageChange}
                        itemsPerPage={itemsPerPage}
                        backendFilter={true}
                        currentPage={currentPage}
                        totalItems={assessSpec?.assessments_total || 0}
                        totalPages={
                          Math.ceil(
                            (assessSpec?.assessments_total || 0) / itemsPerPage,
                          ) || 1
                        }
                        nextSlide={() => setCurrentPage((p) => p + 1)}
                        prevSlide={() =>
                          setCurrentPage((p) => Math.max(1, p - 1))
                        }
                      ></Table>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isRightMenuOpen && (
              <div
                className={`right-sidebar-container hide-scrollbar ${
                  isRightMenuOpen && " test-details-right-sidebar-open "
                } ${
                  commonValues.detailedTestView.isExpanded &&
                  " test-details-right-sidebar-open-minimized "
                }`}
              >
                {commonValues?.detailedTestView?.isExpanded === false ? (
                  <TestDetailsRightView
                    onClose={handleClose}
                    assessment={selectedRow}
                    onUpdateSharedPublicly={onUpdateSharedPublicly}
                    onHiringStageUpdate={onHiringStageUpdate}
                    assessmentsLength={transformedData.length}
                    selectedIndex={transformedData.findIndex(
                      (test) => test.id === selectedRow?.id,
                    )}
                    onSwitchAssessment={(next = false) => {
                      const currentIndex = transformedData.findIndex(
                        (test) => test.id === selectedRow?.id,
                      );
                      if (currentIndex !== -1) {
                        if (next && transformedData[currentIndex + 1]) {
                          setSelectedRow(transformedData[currentIndex + 1]);
                        } else if (transformedData[currentIndex - 1]) {
                          setSelectedRow(transformedData[currentIndex - 1]);
                        }
                      }
                    }}
                  />
                ) : (
                  <TestDetailedView assessment={selectedRow} />
                )}
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="test-detail-page-container hide-scrollbar">
            <div className="test-detail-page-content">
              {!isRightMenuOpen ? (
                <div className="view-with-sidebar">
                  <div
                    className="test-detail-container hide-scrollbar"
                    style={{ height: "calc(100vh - 49px)" }}
                  >
                    <div
                      className={`test-detail-header w-100 d-flex flex-row justify-content-between mb-3 ${
                        isRightMenuOpen && " test-detail-header"
                      }`}
                      style={{ height: "max-content" }}
                    >
                      <div className="test-detail-header-left w-100 d-flex flex-column">
                        <div
                          style={{
                            height: "34px",
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                          }}
                        >
                          <div className="icon-cover" onClick={handleGoBack}>
                            <LeftArrowIcon />
                          </div>
                          <span
                            className="body-2 "
                            style={{ color: "#808191" }}
                          >
                            {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE"
                              ? "Active Assessments"
                              : "Archive Assessments"}
                          </span>
                        </div>
                        <div className="w-100 d-flex justify-content-between mt-2">
                          <span
                            className="headline-3 text-start"
                            style={{
                              maxWidth: "auto",
                              wordBreak: "break-all",
                              overflow: "hidden",
                              display: "inline-block",
                              verticalAlign: "middle",
                              color: "#2B3340",
                            }}
                          >
                            {assessSpec?.curr_assessment_spec?.title}
                          </span>
                        </div>
                        {assessSpec?.curr_assessment_spec?.author && (
                          <div
                            className="d-flex flex-row align-items-center"
                            style={{ gap: "6px" }}
                          >
                            <ProfilePic
                              height={"16px"}
                              width={"16px"}
                              stroke={"#96999C"}
                            />

                            <span className="body-2 black-500">
                              {"Created By "}
                              <span
                                className="body-2"
                                style={{
                                  color: "#121216",
                                  fontWeight: "500",
                                }}
                              >
                                {assessSpec?.curr_assessment_spec?.author
                                  ?.first_name +
                                  " " +
                                  assessSpec?.curr_assessment_spec?.author
                                    ?.last_name}
                              </span>
                            </span>
                          </div>
                        )}
                        <div
                          className="d-flex flex-row align-items-center"
                          style={{ gap: "6px" }}
                        >
                          <CreatedIcon />
                          <span className="body-2 black-500">
                            {"Created on "}
                            <span
                              className="body-2"
                              style={{
                                color: "#121216",
                                fontWeight: "500",
                              }}
                            >
                              {DateToMMDDYYYY(
                                assessSpec?.curr_assessment_spec?.created_at,
                              )}
                            </span>
                          </span>
                        </div>
                        <div
                          className="d-flex flex-row align-items-center"
                          style={{ gap: "6px" }}
                        >
                          <img src={LastActivity} alt="" />
                          <span className="body-2 black-500">
                            {"Last Activity "}
                            <span
                              className="body-2"
                              style={{
                                color: "#121216",
                                fontWeight: "500",
                              }}
                            >
                              {localTimeDifference(
                                assessSpec?.curr_assessment_spec
                                  ?.candidate_last_activity ??
                                  assessSpec?.curr_assessment_spec?.updated_at,
                              )}{" "}
                            </span>
                          </span>
                          <CustomTooltip
                            position="top-start"
                            text={`on ${formatDate(
                              assessSpec?.curr_assessment_spec
                                ?.candidate_last_activity ??
                                assessSpec?.curr_assessment_spec?.updated_at,
                            ).replace("at", "/")}`}
                          >
                            <InfoIcon
                              style={{
                                width: "16px",
                                height: "16px",
                                stroke: "#121216",
                              }}
                            />
                          </CustomTooltip>
                        </div>
                        <div className="d-flex mt-2" style={{ gap: "8px" }}>
                          {/* <CustomTooltip
                            position="top-end"
                            text="View Assessment Criteria"
                          >
                            <div
                              className="icon-cover"
                              onClick={() => {
                                viewCriteria();
                              }}
                            >
                              <FileIcon />
                            </div>
                          </CustomTooltip> */}
                          {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE" &&
                            auth.data.role.name !== "Member" && (
                              <CustomTooltip
                                position="top-end"
                                text="Edit Assessment"
                              >
                                <div
                                  className="icon-cover"
                                  onClick={() => {
                                    editAssessment();
                                  }}
                                >
                                  <EditIcon />
                                </div>
                              </CustomTooltip>
                            )}
                          {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE" &&
                            auth.data.role.name !== "Member" && (
                              <>
                                <CustomTooltip
                                  position="top-end"
                                  text={"Copy Invite Link"}
                                >
                                  <div
                                    className="icon-cover"
                                    onClick={(e) => {
                                      copyLink(e);
                                    }}
                                  >
                                    <LinkIcon stroke={"#808191"} />
                                  </div>
                                </CustomTooltip>
                                <CustomTooltip
                                  position="top-end"
                                  text="Archive Assessment"
                                >
                                  <div
                                    className="icon-cover"
                                    onClick={() => {
                                      setArchiveAssessmentModal({
                                        isOpen: true,
                                      });
                                    }}
                                  >
                                    <ArchiveIcon stroke={"#808191"} />
                                  </div>
                                </CustomTooltip>
                              </>
                            )}
                          {auth.data.role.name !== "Member" && (
                            <CustomTooltip
                              position="top-end"
                              text="Clone Assessment"
                            >
                              <div
                                className="icon-cover"
                                onClick={() => {
                                  cloneAssessment();
                                }}
                              >
                                <CopyIcon />
                              </div>
                            </CustomTooltip>
                          )}
                          {assessSpec?.curr_assessment_spec?.assessments
                            ?.length <= 0 &&
                            auth.data.role.name !== "Member" && (
                              <CustomTooltip
                                position="top-end"
                                text="Delete Assessment"
                              >
                                <div
                                  className="icon-cover"
                                  onClick={() => {
                                    setDeleteAssessmentModal({
                                      isOpen: true,
                                    });
                                  }}
                                >
                                  <TrashIcon />
                                </div>
                              </CustomTooltip>
                            )}
                          {assessSpec?.curr_assessment_spec?.status ===
                            "ACTIVE" &&
                            auth.data.role.name !== "Member" && (
                              <CustomTooltip
                                position="top-end"
                                text="Invite Candidates"
                              >
                                <div
                                  className="icon-cover d-flex align-items-center justify-content-center"
                                  style={{
                                    height: "34px",
                                    width: "34px",
                                    background: "#121216",
                                    borderRadius: "50px",
                                  }}
                                  onClick={() => {
                                    publishAssessment();
                                  }}
                                >
                                  <ShareIcon />
                                </div>
                              </CustomTooltip>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="test-detail-assessments-stats-container mb-3">
                      <div className="assessments-stats">
                        <div
                          className={`assessments-stats-card ${
                            isRightMenuOpen ? "candidate-assess-stats-card" : ""
                          }`}
                          style={
                            isRightMenuOpen
                              ? { width: "22.5%", gap: "1.5em" }
                              : {}
                          }
                        >
                          <div className="stats-card-text">
                            <div
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <CustomTooltip
                                customPosition={{
                                  bottom: "42px",
                                  right: "5px",
                                }}
                                text={"Assessment Duration"}
                              >
                                <span
                                  className="body-2  dark-50"
                                  style={{
                                    color: "#808191",
                                    display: isRightMenuOpen ? "none" : "block",
                                  }}
                                >
                                  Total
                                </span>
                              </CustomTooltip>
                              <CustomTooltip
                                customPosition={{ bottom: "12px", left: "8px" }}
                                text={
                                  assessSpec?.curr_assessment_spec
                                    ?.objective_test_duration !== undefined ||
                                  assessSpec?.curr_assessment_spec
                                    ?.objective_test_duration !== null
                                    ? "This cumulative duration applies to objective tests (skill, coding, value fitness). Text and Case Study tests have flexible time (hours to days), while Video and Upload tests are without set time limits."
                                    : "This is the cumulative duration for all test types including Case Study and Text Responses"
                                }
                              >
                                <InfoIcon
                                  style={{
                                    position: "absolute",
                                    right: "0px",
                                    bottom: "4px",
                                    width: "14px",
                                    height: "14px",
                                    stroke: "#808191",
                                    display: isRightMenuOpen ? "none" : "block",
                                  }}
                                />
                              </CustomTooltip>
                            </div>
                            <span
                              className={`headline-5 dark-100 ${
                                isRightMenuOpen ? "body-2" : ""
                              }`}
                            >
                              {secondsTohhmm(
                                assessSpec?.curr_assessment_spec
                                  ?.objective_test_duration ||
                                  assessSpec?.curr_assessment_spec?.duration ||
                                  0,
                              )}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <TimeStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        <div
                          className={`assessments-stats-card ${
                            isRightMenuOpen ? "candidate-assess-stats-card" : ""
                          }`}
                          style={
                            isRightMenuOpen
                              ? { width: "22.5%", gap: "1.5em" }
                              : {}
                          }
                        >
                          <div className="stats-card-text">
                            <span
                              className="body-2 dark-50"
                              style={{
                                color: "#808191",
                                display: isRightMenuOpen ? "none" : "block",
                              }}
                            >
                              Expiry
                            </span>
                            <span
                              className={`headline-5 dark-100 ${
                                isRightMenuOpen ? "body-2" : ""
                              }`}
                            >
                              {assessSpec?.curr_assessment_spec?.deadline
                                ? `In ${
                                    assessSpec?.curr_assessment_spec?.deadline /
                                    86400
                                  } Days`
                                : "None"}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <ExpiryStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        <div
                          className={`assessments-stats-card ${
                            isRightMenuOpen ? "candidate-assess-stats-card" : ""
                          }`}
                          style={
                            isRightMenuOpen
                              ? { width: "22.5%", gap: "1.5em" }
                              : {}
                          }
                        >
                          <div className="stats-card-text">
                            <span
                              className="body-2  dark-50"
                              style={{
                                color: "#808191",
                                display: isRightMenuOpen ? "none" : "block",
                              }}
                            >
                              Invites Sent
                            </span>
                            <span
                              className={`headline-5 dark-100 ${
                                isRightMenuOpen ? "body-2" : ""
                              }`}
                            >
                              {/* {assesment?.invited || 0} */}
                              {assessSpec?.assessments_total || 0}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <InvitedStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                        <div
                          className={`assessments-stats-card ${
                            isRightMenuOpen ? "candidate-assess-stats-card" : ""
                          }`}
                          style={
                            isRightMenuOpen
                              ? { width: "22.5%", gap: "1.5em" }
                              : {}
                          }
                        >
                          <div className="stats-card-text">
                            <span
                              className="body-2  dark-50"
                              style={{
                                color: "#808191",
                                display: isRightMenuOpen ? "none" : "block",
                              }}
                            >
                              Evaluations
                            </span>
                            <span
                              className={`headline-5 dark-100 ${
                                isRightMenuOpen ? "body-2" : ""
                              }`}
                            >
                              {/* {assesment?.completed || 0} */}
                              {completedAssessment?.length || 0}
                            </span>
                          </div>
                          <div className="AssessmentsStatsIcon-container">
                            <AttemptsStatsIcon className="AssessmentsStatsIcon" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ background: "white", borderRadius: "24px" }}>
                      <div className="candidate-details-container">
                        <div
                          className="w-100"
                          style={{
                            height: "calc(100vh - 325px)",
                            borderRadius: "24px",
                            background: "white",
                          }}
                        >
                          <Table
                            headers={
                              isRightMenuOpen
                                ? OnOpenRightSideBartestTableHeader
                                : testTableHeader
                            }
                            data={isTableDataRefreshing ? [] : testData}
                            setData={setTestData}
                            onSelectRow={(row) => {
                              setIsRightMenuOpen(true);
                              setCommonValues({
                                ...commonValues,
                                isSideBarExpanded: false,
                              });
                              setSelectedRow(row);
                            }}
                            searchColumns={searchColumns}
                            // disableSearchInput={true}
                            customSorting={customSorting}
                            enableCheckbox={true}
                            highlightActiveRow={highlightActiveRow}
                            setHighlightActiveRow={setHighlightActiveRow}
                            testDetails={true}
                            customSearch={false}
                            handleBulkUpdate={handleBulkUpdate}
                            nullTableTitle={"No Assessments to show"}
                            nullTableDescription={`Try adjusting your search query or filters`}
                            nullTableLoading={isTableDataRefreshing}
                            setSelectedsortOption={setSelectedsortOption}
                            selectedsortOption={selectedsortOption}
                            handleRowSelect={handleRowSelect}
                            selectedId={selectedRow?.id}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            itemsPerPage={itemsPerPage}
                            backendFilter={true}
                            currentPage={currentPage}
                            totalItems={assessSpec?.assessments_total || 0}
                            totalPages={
                              Math.ceil(
                                (assessSpec?.assessments_total || 0) /
                                  itemsPerPage,
                              ) || 1
                            }
                            nextSlide={() => setCurrentPage((p) => p + 1)}
                            prevSlide={() =>
                              setCurrentPage((p) => Math.max(1, p - 1))
                            }
                          ></Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={`d-flex flex-column hide-scrollbar`}>
                  <MinimizeViewBar />
                  {commonValues?.detailedTestView?.isExpanded === false ? (
                    <TestDetailsRightView
                      onClose={handleClose}
                      assessment={selectedRow}
                      onUpdateSharedPublicly={onUpdateSharedPublicly}
                      onHiringStageUpdate={onHiringStageUpdate}
                      assessmentsLength={transformedData.length}
                      selectedIndex={transformedData.findIndex(
                        (test) => test.id === selectedRow?.id,
                      )}
                      onSwitchAssessment={(next = false) => {
                        const currentIndex = transformedData.findIndex(
                          (test) => test.id === selectedRow?.id,
                        );
                        if (currentIndex !== -1) {
                          if (next && transformedData[currentIndex + 1]) {
                            setSelectedRow(transformedData[currentIndex + 1]);
                          } else if (transformedData[currentIndex - 1]) {
                            setSelectedRow(transformedData[currentIndex - 1]);
                          }
                        }
                      }}
                    />
                  ) : (
                    <TestDetailedView assessment={selectedRow} />
                  )}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
